import { logGAEvent } from 'lib/firebase/ga_analytics';
import { ANALYTICS_SERVICE_EVENT_NAMES } from 'lib/firebase/ga_events';

const redirectToBranchAppStore = (branch: string) => {
  if (!branch) {
    return;
  }

  logGAEvent({
    event_name: 'service_event',
    service_event_name: ANALYTICS_SERVICE_EVENT_NAMES.BRANCH_APP_STORE_REDIRECT
  });

  window.location.href = branch;
};

export default redirectToBranchAppStore;
